import React from 'react';
import { MessageCircleIcon, InstagramIcon, FacebookIcon, TwitterIcon, YoutubeIcon } from 'lucide-react';
export function Footer() {
  return <footer className="mt-12 py-6" data-id="element-52">
      <div className="mb-6" data-id="element-53">
        <h3 className="font-bold text-gray-800 mb-3" data-id="element-54">Contact Support</h3>
        <div className="flex flex-col sm:flex-row gap-3" data-id="element-55">
          <a href="https://t.me/m/bsr2XMoyY2M0" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 bg-blue-50 text-blue-700 py-2 px-4 rounded-lg hover:bg-blue-100 transition" data-id="element-56">
            <MessageCircleIcon className="h-5 w-5" data-id="element-57" />
            <span data-id="element-58">Telegram Support</span>
          </a>
          <a href="mailto:support@greenhs.com" className="flex items-center gap-2 bg-gray-100 text-gray-700 py-2 px-4 rounded-lg hover:bg-gray-200 transition" data-id="element-59">
            <span data-id="element-60">contact@greenhs</span>
          </a>
        </div>
        <p className="text-gray-600 text-sm mt-2" data-id="element-61">
          Need help? We're one tap away!
        </p>
      </div>
      <div className="mb-6" data-id="element-62">
        <h3 className="font-bold text-gray-800 mb-3" data-id="element-63">Follow Us</h3>
        <div className="flex gap-4" data-id="element-64">
          <a href="https://www.instagram.com/greenhighstakers?igsh=MTc1dmJwYWpreWwwdw%3D%3D&utm_source=qr" className="text-gray-600 hover:text-gray-900" data-id="element-65">
            <InstagramIcon className="h-6 w-6" data-id="element-66" />
          </a>
          <a href="https://www.facebook.com/share/1CPJvD5dKp/?mibextid=wwXIfr" className="text-gray-600 hover:text-gray-900" data-id="element-67">
            <FacebookIcon className="h-6 w-6" data-id="element-68" />
          </a>
          <a href="#" className="text-gray-600 hover:text-gray-900" data-id="element-69">
            <TwitterIcon className="h-6 w-6" data-id="element-70" />
          </a>
          <a href="#" className="text-gray-600 hover:text-gray-900" data-id="element-71">
            <YoutubeIcon className="h-6 w-6" data-id="element-72" />
          </a>
        </div>
      </div>
      <div className="text-center text-sm text-gray-500" data-id="element-73">
        <div className="mb-2" data-id="element-74">
          <a href="#" className="text-gray-500 hover:text-gray-700 mx-2" data-id="element-75">
            Terms of Use
          </a>
          <a href="#" className="text-gray-500 hover:text-gray-700 mx-2" data-id="element-76">
            Privacy Policy
          </a>
        </div>
        <p data-id="element-77">© 2025 GreenHS. All Rights Reserved.</p>
      </div>
    </footer>;
}